import { DataProvider } from 'react-admin'
import { TransactionInfoResponse } from '../../dto/device/ticket-machines/automat-api/transaction-info-response'

const fakeFiles: TransactionInfoResponse[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
